import { Footer, Navbar } from "@milestone/component-library";
import {
  Header,
  LoginArea,
  LoginButton,
  LoginContainer,
  LoginSide,
  LoginText,
  Main,
  Page,
} from "./Login.styles";

import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { loginRequest } from "../../../authConfig";
import { InteractionStatus } from "@azure/msal-browser";
import { useState } from "react";
import { LoginError } from "../../../app/App";

export const Login = () => {
  const { instance, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const error = localStorage.getItem(LoginError);
  const [hasError, setHasError] = useState(typeof error === "string");

  const handleLogin = () => {
    (async () => {
      if (inProgress === InteractionStatus.None && !isAuthenticated) {
        try {
          instance.loginRedirect(loginRequest);
        } catch (error) {
          setHasError(true);
        }
      }
    })();
  };

  return (
    <Page>
      <Navbar isLoggedIn={false} />
      <Main>
        <LoginContainer>
          <LoginArea>
            <Header>Member Portal</Header>
            <LoginText>
              Welcome to the MPACT Work Portal: a platform for leader & team
              performance metrics, supporting team member relations, and all
              things MPACT!
            </LoginText>
            <LoginButton onClick={handleLogin}>Login</LoginButton>
            {hasError ? (
              <p>There was an error logging you in. Please try again.</p>
            ) : null}
          </LoginArea>
        </LoginContainer>
        <LoginSide></LoginSide>
      </Main>
      <Footer />
    </Page>
    //   </UnauthenticatedTemplate>

    //   <AuthenticatedTemplate>
    //     {user.permissions.includes("DASHBOARD_VIEW_EXECUTIVE") ? (
    //       <Redirect to="/dashboard" />
    //     ) : user.permissions.includes("MEMBER_ADMIN_VIEW_LIST") ? (
    //       <Redirect to="/admin" />
    //     ) : (
    //       <Redirect to="/employeeDetails" />
    //     )}
    //   </AuthenticatedTemplate>
    // </>
  );
};
